import ApiMServer from "services/ApiMServer";

const parseNumber = (value, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const normalizeAssistencia = (item = {}) => {
  const currency = item.currency || "BRL";
  const rawDesconto = item.desconto ?? item.discount ?? null;
  const status =
    typeof item.status === "boolean"
      ? item.status
        ? "ativo"
        : "inativo"
      : (item.status || "ativo");

  return {
    _id: String(item._id || item.id || ""),
    nome: item.nome || item.name || "",
    cidade: item.cidade || item.city || "",
    estado: item.estado || item.uf || item.state || "",
    email: item.email || "",
    emailhp: item.emailhp || item.emailHp || item.helpDeskEmail || "",
    valor: parseNumber(item.valor ?? item.value),
    valorhp: parseNumber(item.valorhp ?? item.valueHp),
    valorloc: parseNumber(item.valorloc ?? item.valueLoc),
    currency,
    format: item.format || (currency === "USD" ? "en-US" : "pt-BR"),
    desconto: rawDesconto === null || rawDesconto === "" ? null : parseNumber(rawDesconto, null),
    status,
    logo: item.logo || "",
    assinatura: item.assinatura || "",
  };
};

export const getAssistencias = async () => {
  const { data } = await ApiMServer.get("/api/v1/assistencias");
  const rawList = Array.isArray(data)
    ? data
    : Array.isArray(data?.assistencias)
      ? data.assistencias
      : [];

  return rawList
    .map(normalizeAssistencia)
    .filter((assistencia) => Boolean(assistencia._id));
};

export const getAssistenciaById = async (id) => {
  if (!id) return null;

  const { data } = await ApiMServer.get(`/api/v1/assistencias/${id}`);
  const rawAssistencia = data?.assistencia || data;
  if (!rawAssistencia) return null;

  const assistencia = normalizeAssistencia(rawAssistencia);
  return assistencia._id ? assistencia : null;
};

export const createAssistencia = async (formData) => {
  const { data } = await ApiMServer.post("/assitencia/create", formData);
  return data?.assistencia || data;
};

export const updateAssistencia = async (id, formData) => {
  if (!id) {
    throw new Error("ID da assistência é obrigatório para edição.");
  }

  const { data } = await ApiMServer.put(`/api/v1/assistencias/${id}`, formData);
  return data?.assistencia || data;
};

export default [];
